var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rose-page" }, [
    _c(
      "div",
      { staticClass: "petals", attrs: { "aria-hidden": "true" } },
      _vm._l(_vm.petals, function (p, i) {
        return _c("span", { key: i, staticClass: "petal", style: p.style })
      }),
      0
    ),
    _c("div", { staticClass: "rose-card", class: { burst: _vm.burst } }, [
      _c(
        "div",
        {
          staticClass: "rose-wrap",
          class: { burst: _vm.burst },
          on: { click: _vm.bloom },
        },
        [
          _c(
            "svg",
            { staticClass: "rose-svg", attrs: { viewBox: "0 0 200 200" } },
            [
              _c(
                "defs",
                [
                  _c(
                    "radialGradient",
                    {
                      attrs: { id: "roseGrad", cx: "50%", cy: "38%", r: "70%" },
                    },
                    [
                      _c("stop", {
                        attrs: { offset: "0%", "stop-color": "#ff8494" },
                      }),
                      _c("stop", {
                        attrs: { offset: "55%", "stop-color": "#cf1f3d" },
                      }),
                      _c("stop", {
                        attrs: { offset: "100%", "stop-color": "#7d0f22" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "radialGradient",
                    {
                      attrs: { id: "roseCore", cx: "50%", cy: "45%", r: "60%" },
                    },
                    [
                      _c("stop", {
                        attrs: { offset: "0%", "stop-color": "#ff9aa8" },
                      }),
                      _c("stop", {
                        attrs: { offset: "100%", "stop-color": "#96122b" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "g",
                { staticClass: "petals-layer" },
                _vm._l(8, function (a) {
                  return _c("ellipse", {
                    key: "o" + a,
                    attrs: {
                      cx: "100",
                      cy: "72",
                      rx: "33",
                      ry: "45",
                      fill: "url(#roseGrad)",
                      transform: "rotate(" + (a - 1) * 45 + " 100 100)",
                      opacity: "0.95",
                    },
                  })
                }),
                0
              ),
              _c(
                "g",
                { staticClass: "petals-inner" },
                _vm._l(6, function (a) {
                  return _c("ellipse", {
                    key: "i" + a,
                    attrs: {
                      cx: "100",
                      cy: "84",
                      rx: "24",
                      ry: "32",
                      fill: "#b81734",
                      transform: "rotate(" + ((a - 1) * 60 + 30) + " 100 100)",
                    },
                  })
                }),
                0
              ),
              _c("circle", {
                attrs: {
                  cx: "100",
                  cy: "100",
                  r: "24",
                  fill: "url(#roseCore)",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M100 82c13 5 19 20 10 29-7 8-20 5-22-6-2-9 7-15 14-11",
                  fill: "none",
                  stroke: "#ffb3bf",
                  "stroke-width": "3.5",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
          _c("span", { staticClass: "burst-flash" }),
          _vm._l(2, function (r) {
            return _c("span", {
              key: "r" + r,
              staticClass: "burst-ring",
              style: { animationDelay: (r - 1) * 0.12 + "s" },
            })
          }),
          _vm._l(_vm.burstPetals, function (p, i) {
            return _c(
              "span",
              {
                key: "p" + i,
                staticClass: "burst-arm",
                style: { transform: "rotate(" + p.a + "deg)" },
              },
              [
                _c("i", {
                  staticClass: "burst-petal",
                  class: "fly-" + p.tier,
                  style: p.style,
                }),
              ]
            )
          }),
          _vm._l(_vm.burstSparks, function (s, i) {
            return _c(
              "span",
              { key: "sp" + i, staticClass: "burst-spark", style: s.style },
              [_vm._v(_vm._s(s.ch))]
            )
          }),
        ],
        2
      ),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "verse-block" },
        _vm._l(_vm.verses, function (v, i) {
          return _c(
            "p",
            {
              key: "v" + i,
              staticClass: "verse-line",
              style: { animationDelay: 0.1 + i * 0.32 + "s" },
            },
            [_vm._v(_vm._s(v))]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "letter-body" },
        _vm._l(_vm.paragraphs, function (p, i) {
          return _c(
            "p",
            {
              key: i,
              staticClass: "letter-p",
              style: { animationDelay: 0.2 + i * 0.15 + "s" },
            },
            [_vm._v(_vm._s(p))]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "rose-row" },
        _vm._l(3, function (n) {
          return _c(
            "svg",
            {
              key: "m" + n,
              staticClass: "rose-mini",
              attrs: { viewBox: "0 0 200 200" },
            },
            [
              _c("circle", {
                attrs: {
                  cx: "100",
                  cy: "100",
                  r: "70",
                  fill: "#a5122c",
                  opacity: "0.25",
                },
              }),
              _vm._l(6, function (a) {
                return _c("ellipse", {
                  key: "mo" + a,
                  attrs: {
                    cx: "100",
                    cy: "80",
                    rx: "26",
                    ry: "36",
                    fill: "url(#roseGrad)",
                    transform: "rotate(" + (a - 1) * 60 + " 100 100)",
                  },
                })
              }),
              _c("circle", {
                attrs: {
                  cx: "100",
                  cy: "100",
                  r: "22",
                  fill: "url(#roseCore)",
                },
              }),
            ],
            2
          )
        }),
        0
      ),
      _vm._m(1),
    ]),
    _c("div", { staticClass: "rose-foot" }, [
      _c("span", { staticClass: "foot-heart", on: { click: _vm.bloom } }, [
        _vm._v("❤"),
      ]),
      _c("span", [_vm._v("点一下玫瑰，它替你红一次")]),
    ]),
    _c("div", { staticClass: "letter-back", on: { click: _vm.goBack } }, [
      _c("span", { staticClass: "back-ico" }, [_vm._v("‹")]),
      _vm._v(" 返回列表"),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "name-block" }, [
      _c("div", { staticClass: "name-cn" }, [_vm._v("小 张 玲")]),
      _c("div", { staticClass: "name-line" }, [
        _vm._v("入目无他人 · 四下皆是你"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "letter-sign" }, [
      _c("span", { staticClass: "sign-name" }, [
        _vm._v("—— 那个会一直陪着你的人"),
      ]),
      _c("span", { staticClass: "sign-date" }, [_vm._v("2026年9月29日")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }